
import Hero from './components/Hero';
import Intro from './components/Intro';
import PriceReport from './components/PriceReport';
import About from './components/About';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Process from './components/Process';
import Commitment from './components/Commitment';
import ServiceArea from './components/ServiceArea';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Intro />
      <PriceReport />
      <About />
      <Services />
      <WhyChooseUs />
      <Process />
      <Commitment />
      <ServiceArea />
      <Contact />
      <Footer />
    </div>
  );
}
